// import React, { useRef } from "react";
// import { motion, useInView } from "framer-motion";
// import {
//   Box,
//   Typography,
//   Button,
//   AppBar,
//   Toolbar,
//   Stack,
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   TextField,
//   Paper,
//   Chip,
//   Rating,
//   IconButton,
// } from "@mui/material";
// import { AccountBalance, Business, Cloud, Email, ExpandMore, Facebook, FormatQuote, Gavel, LinkedIn, LocationOn, Phone, Schedule, Security, Speed, TrendingUp, Twitter } from "@mui/icons-material";

// const navItems = [
//   { label: "About", id: "about" },
//   { label: "Services", id: "services" },
//   { label: "Testimonials", id: "testimonials" },
//   { label: "Pricing", id: "pricing" },
//   { label: "FAQ", id: "faq" },
//   { label: "Contact", id: "contact" },
// ];

// // Animation variants
// const fadeInUp = {
//   hidden: { opacity: 0, y: 60 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// };

// const staggerContainer = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.2,
//       delayChildren: 0.1,
//     },
//   },
// };

// const scaleIn = {
//   hidden: { opacity: 0, scale: 0.8 },
//   visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
// };

// // Animated Section Component
// const AnimatedSection = ({ children, variants = fadeInUp }) => {
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, margin: "-100px" });

//   return (
//     <motion.div
//       ref={ref}
//       initial="hidden"
//       animate={isInView ? "visible" : "hidden"}
//       variants={variants}
//     >
//       {children}
//     </motion.div>
//   );
// };

// // Header Component
// const Header = () => (
//   <AppBar
//     position="fixed"
//     sx={{
//       backgroundColor: "rgba(255,255,255,0.95)",
//       backdropFilter: "blur(10px)",
//       color: "#1976d2",
//     }}
//   >
//     <Toolbar>
//       <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
//         <Gavel sx={{ mr: 1 }} />
//         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//           LegalTech Pro
//         </Typography>
//       </Box>
//       <Stack direction="row" spacing={2}>
//         {navItems.map((item) => (
//           <Button key={item.id} color="inherit" sx={{ textTransform: "none" }}>
//             {item.label}
//           </Button>
//         ))}
//         <Button
//           variant="contained"
//           sx={{ borderRadius: 8, textTransform: "none" }}
//         >
//           Get Started
//         </Button>
//       </Stack>
//     </Toolbar>
//   </AppBar>
// );

// // Hero Section
// const HeroSection = () => (
//   <Box
//     sx={{
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       minHeight: "100vh",
//       display: "flex",
//       alignItems: "center",
//       position: "relative",
//       overflow: "hidden",
//     }}
//   >
//     <Container maxWidth="lg">
//       <Grid container spacing={6} alignItems="center">
//         <Grid item xs={12} md={6}>
//           <motion.div
//             initial={{ opacity: 0, x: -100 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8, delay: 0.2 }}
//           >
//             <Typography
//               variant="h6"
//               sx={{ color: "#E8EAF6", mb: 2, fontWeight: 500 }}
//             >
//               Next-Generation Legal Software
//             </Typography>
//             <Typography
//               variant="h2"
//               sx={{
//                 color: "white",
//                 fontWeight: "bold",
//                 mb: 3,
//                 fontSize: { xs: "2.5rem", md: "3.5rem" },
//               }}
//             >
//               Transform Your Law Practice
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{ color: "#E8EAF6", mb: 4, lineHeight: 1.6 }}
//             >
//               Streamline case management, automate billing, enhance client
//               communication, and grow your firm with our comprehensive legal
//               practice management solution.
//             </Typography>
//             <Stack direction="row" spacing={2}>
//               <motion.div
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 <Button
//                   variant="contained"
//                   size="large"
//                   sx={{
//                     py: 2,
//                     px: 4,
//                     borderRadius: 8,
//                     backgroundColor: "white",
//                     color: "#1976d2",
//                     "&:hover": { backgroundColor: "#f5f5f5" },
//                   }}
//                 >
//                   Start Free Trial
//                 </Button>
//               </motion.div>
//               <motion.div
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 <Button
//                   variant="outlined"
//                   size="large"
//                   sx={{
//                     py: 2,
//                     px: 4,
//                     borderRadius: 8,
//                     borderColor: "white",
//                     color: "white",
//                     "&:hover": {
//                       borderColor: "#E8EAF6",
//                       backgroundColor: "rgba(255,255,255,0.1)",
//                     },
//                   }}
//                 >
//                   Watch Demo
//                 </Button>
//               </motion.div>
//             </Stack>
//           </motion.div>
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.8, delay: 0.4 }}
//           >
//             <Box
//               sx={{
//                 background: "rgba(255,255,255,0.1)",
//                 backdropFilter: "blur(20px)",
//                 borderRadius: 4,
//                 p: 4,
//                 border: "1px solid rgba(255,255,255,0.2)",
//               }}
//             >
//               <Typography
//                 variant="h5"
//                 sx={{ color: "white", mb: 3, textAlign: "center" }}
//               >
//                 Trusted by 10,000+ Law Firms
//               </Typography>
//               <Grid container spacing={2}>
//                 {[
//                   {
//                     icon: <Security />,
//                     label: "Bank-Level Security",
//                     value: "256-bit SSL",
//                   },
//                   {
//                     icon: <Speed />,
//                     label: "Lightning Fast",
//                     value: "99.9% Uptime",
//                   },
//                   {
//                     icon: <Cloud />,
//                     label: "Cloud-Based",
//                     value: "Access Anywhere",
//                   },
//                   {
//                     icon: <TrendingUp />,
//                     label: "Grow Revenue",
//                     value: "35% Average",
//                   },
//                 ].map((item, index) => (
//                   <Grid item xs={6} key={index}>
//                     <Box sx={{ textAlign: "center", color: "white" }}>
//                       {item.icon}
//                       <Typography variant="body2" sx={{ mt: 1 }}>
//                         {item.label}
//                       </Typography>
//                       <Typography variant="caption">{item.value}</Typography>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>
//           </motion.div>
//         </Grid>
//       </Grid>
//     </Container>
//   </Box>
// );

// // About Section
// const AboutSection = () => (
//   <Container maxWidth="lg" sx={{ py: 10 }} id="about">
//     <AnimatedSection>
//       <Typography
//         variant="h3"
//         align="center"
//         sx={{ mb: 6, fontWeight: "bold" }}
//       >
//         Why Choose LegalTech Pro?
//       </Typography>
//     </AnimatedSection>

//     <motion.div
//       variants={staggerContainer}
//       initial="hidden"
//       whileInView="visible"
//       viewport={{ once: true }}
//     >
//       <Grid container spacing={4}>
//         {[
//           {
//             icon: <AccountBalance sx={{ fontSize: 60, color: "#1976d2" }} />,
//             title: "Comprehensive Case Management",
//             description:
//               "Organize cases, track deadlines, manage documents, and collaborate with your team seamlessly.",
//           },
//           {
//             icon: <Schedule sx={{ fontSize: 60, color: "#1976d2" }} />,
//             title: "Automated Time Tracking",
//             description:
//               "Accurate billable hours tracking with smart timers and automatic activity detection.",
//           },
//           {
//             icon: <Business sx={{ fontSize: 60, color: "#1976d2" }} />,
//             title: "Client Portal & Communication",
//             description:
//               "Secure client portal for document sharing, messaging, and real-time case updates.",
//           },
//         ].map((item, index) => (
//           <Grid item xs={12} md={4} key={index}>
//             <motion.div variants={fadeInUp}>
//               <Card
//                 sx={{
//                   height: "100%",
//                   textAlign: "center",
//                   p: 3,
//                   transition: "transform 0.3s ease-in-out",
//                   "&:hover": { transform: "translateY(-10px)" },
//                 }}
//               >
//                 <CardContent>
//                   {item.icon}
//                   <Typography variant="h5" sx={{ my: 2, fontWeight: "bold" }}>
//                     {item.title}
//                   </Typography>
//                   <Typography variant="body1" color="text.secondary">
//                     {item.description}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </motion.div>
//           </Grid>
//         ))}
//       </Grid>
//     </motion.div>
//   </Container>
// );

// // Services Section
// const ServicesSection = () => (
//   <Box sx={{ backgroundColor: "#f8f9fa", py: 10 }} id="services">
//     <Container maxWidth="lg">
//       <AnimatedSection>
//         <Typography
//           variant="h3"
//           align="center"
//           sx={{ mb: 6, fontWeight: "bold" }}
//         >
//           Complete Legal Practice Solution
//         </Typography>
//       </AnimatedSection>

//       <motion.div
//         variants={staggerContainer}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <Grid container spacing={4}>
//           {[
//             {
//               title: "Case & Matter Management",
//               features: [
//                 "Case tracking",
//                 "Deadline management",
//                 "Document organization",
//                 "Task assignment",
//               ],
//               color: "#4CAF50",
//             },
//             {
//               title: "Time & Billing",
//               features: [
//                 "Automated time tracking",
//                 "Invoice generation",
//                 "Payment processing",
//                 "Trust accounting",
//               ],
//               color: "#2196F3",
//             },
//             {
//               title: "Document Management",
//               features: [
//                 "Secure storage",
//                 "Version control",
//                 "Template library",
//                 "E-signature integration",
//               ],
//               color: "#FF9800",
//             },
//             {
//               title: "Client Communication",
//               features: [
//                 "Client portal",
//                 "Secure messaging",
//                 "Appointment scheduling",
//                 "Status updates",
//               ],
//               color: "#9C27B0",
//             },
//           ].map((service, index) => (
//             <Grid item xs={12} md={6} key={index}>
//               <motion.div variants={scaleIn}>
//                 <Card sx={{ height: "100%", p: 3 }}>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <Box
//                       sx={{
//                         width: 10,
//                         height: 40,
//                         backgroundColor: service.color,
//                         borderRadius: 1,
//                         mr: 2,
//                       }}
//                     />
//                     <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//                       {service.title}
//                     </Typography>
//                   </Box>
//                   <Stack spacing={1}>
//                     {service.features.map((feature, idx) => (
//                       <Typography
//                         key={idx}
//                         variant="body1"
//                         sx={{ display: "flex", alignItems: "center" }}
//                       >
//                         <Box
//                           sx={{
//                             width: 6,
//                             height: 6,
//                             backgroundColor: service.color,
//                             borderRadius: "50%",
//                             mr: 2,
//                           }}
//                         />
//                         {feature}
//                       </Typography>
//                     ))}
//                   </Stack>
//                 </Card>
//               </motion.div>
//             </Grid>
//           ))}
//         </Grid>
//       </motion.div>
//     </Container>
//   </Box>
// );

// // Testimonials Section
// const TestimonialsSection = () => (
//   <Container maxWidth="lg" sx={{ py: 10 }} id="testimonials">
//     <AnimatedSection>
//       <Typography
//         variant="h3"
//         align="center"
//         sx={{ mb: 6, fontWeight: "bold" }}
//       >
//         What Our Clients Say
//       </Typography>
//     </AnimatedSection>

//     <motion.div
//       variants={staggerContainer}
//       initial="hidden"
//       whileInView="visible"
//       viewport={{ once: true }}
//     >
//       <Grid container spacing={4}>
//         {[
//           {
//             name: "Sarah Mitchell",
//             title: "Managing Partner, Mitchell & Associates",
//             rating: 5,
//             quote:
//               "LegalTech Pro transformed our practice. We've increased efficiency by 40% and our clients love the transparency.",
//           },
//           {
//             name: "David Chen",
//             title: "Solo Practitioner",
//             rating: 5,
//             quote:
//               "As a solo attorney, this platform handles everything I need. The automated billing alone saves me 10 hours per week.",
//           },
//           {
//             name: "Jennifer Rodriguez",
//             title: "Senior Partner, Rodriguez Law Group",
//             rating: 5,
//             quote:
//               "The client portal has revolutionized our client relationships. Communication is seamless and professional.",
//           },
//         ].map((testimonial, index) => (
//           <Grid item xs={12} md={4} key={index}>
//             <motion.div variants={fadeInUp}>
//               <Card sx={{ height: "100%", p: 3, position: "relative" }}>
//                 <FormatQuote
//                   sx={{
//                     position: "absolute",
//                     top: 10,
//                     right: 10,
//                     color: "#e0e0e0",
//                     fontSize: 40,
//                   }}
//                 />
//                 <Rating value={testimonial.rating} readOnly sx={{ mb: 2 }} />
//                 <Typography variant="body1" sx={{ mb: 3, fontStyle: "italic" }}>
//                   "{testimonial.quote}"
//                 </Typography>
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Avatar sx={{ mr: 2, bgcolor: "#1976d2" }}>
//                     {testimonial.name
//                       .split(" ")
//                       .map((n) => n[0])
//                       .join("")}
//                   </Avatar>
//                   <Box>
//                     <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//                       {testimonial.name}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {testimonial.title}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Card>
//             </motion.div>
//           </Grid>
//         ))}
//       </Grid>
//     </motion.div>
//   </Container>
// );

// // Pricing Section
// const PricingSection = () => (
//   <Box sx={{ backgroundColor: "#f8f9fa", py: 10 }} id="pricing">
//     <Container maxWidth="lg">
//       <AnimatedSection>
//         <Typography
//           variant="h3"
//           align="center"
//           sx={{ mb: 6, fontWeight: "bold" }}
//         >
//           Simple, Transparent Pricing
//         </Typography>
//       </AnimatedSection>

//       <motion.div
//         variants={staggerContainer}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <Grid container spacing={4} justifyContent="center">
//           {[
//             {
//               title: "Starter",
//               price: "$49",
//               period: "/attorney/month",
//               features: [
//                 "Up to 5 attorneys",
//                 "Basic case management",
//                 "Time tracking",
//                 "Email support",
//               ],
//               popular: false,
//             },
//             {
//               title: "Professional",
//               price: "$89",
//               period: "/attorney/month",
//               features: [
//                 "Up to 25 attorneys",
//                 "Advanced features",
//                 "Client portal",
//                 "Priority support",
//                 "Integrations",
//               ],
//               popular: true,
//             },
//             {
//               title: "Enterprise",
//               price: "Custom",
//               period: "pricing",
//               features: [
//                 "Unlimited attorneys",
//                 "Custom workflows",
//                 "API access",
//                 "Dedicated support",
//                 "On-premise option",
//               ],
//               popular: false,
//             },
//           ].map((plan, index) => (
//             <Grid item xs={12} md={4} key={index}>
//               <motion.div variants={scaleIn}>
//                 <Card
//                   sx={{
//                     height: "100%",
//                     p: 4,
//                     textAlign: "center",
//                     border: plan.popular ? 3 : 1,
//                     borderColor: plan.popular ? "#1976d2" : "#e0e0e0",
//                     position: "relative",
//                   }}
//                 >
//                   {plan.popular && (
//                     <Chip
//                       label="Most Popular"
//                       color="primary"
//                       sx={{
//                         position: "absolute",
//                         top: -12,
//                         left: "50%",
//                         transform: "translateX(-50%)",
//                       }}
//                     />
//                   )}
//                   <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
//                     {plan.title}
//                   </Typography>
//                   <Typography
//                     variant="h3"
//                     sx={{ mb: 1, fontWeight: "bold", color: "#1976d2" }}
//                   >
//                     {plan.price}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                     sx={{ mb: 3 }}
//                   >
//                     {plan.period}
//                   </Typography>
//                   <Stack spacing={2} sx={{ mb: 4 }}>
//                     {plan.features.map((feature, idx) => (
//                       <Typography key={idx} variant="body1">
//                         ✓ {feature}
//                       </Typography>
//                     ))}
//                   </Stack>
//                   <Button
//                     variant={plan.popular ? "contained" : "outlined"}
//                     fullWidth
//                     size="large"
//                     sx={{ borderRadius: 8 }}
//                   >
//                     Get Started
//                   </Button>
//                 </Card>
//               </motion.div>
//             </Grid>
//           ))}
//         </Grid>
//       </motion.div>
//     </Container>
//   </Box>
// );

// // FAQ Section
// const FAQSection = () => (
//   <Container maxWidth="lg" sx={{ py: 10 }} id="faq">
//     <AnimatedSection>
//       <Typography
//         variant="h3"
//         align="center"
//         sx={{ mb: 6, fontWeight: "bold" }}
//       >
//         Frequently Asked Questions
//       </Typography>
//     </AnimatedSection>

//     <motion.div
//       variants={staggerContainer}
//       initial="hidden"
//       whileInView="visible"
//       viewport={{ once: true }}
//     >
//       <Box maxWidth="md" mx="auto">
//         {[
//           {
//             question: "Is my data secure with LegalTech Pro?",
//             answer:
//               "Yes, we use bank-level 256-bit SSL encryption and are fully compliant with attorney-client privilege requirements. Your data is stored in secure, SOC 2 certified data centers.",
//           },
//           {
//             question: "Can I import data from my current system?",
//             answer:
//               "Absolutely! We provide free data migration services and can import from most popular legal software platforms including Clio, MyCase, and PracticePanther.",
//           },
//           {
//             question: "Do you offer training and support?",
//             answer:
//               "Yes, we provide comprehensive onboarding, training sessions, and ongoing support. Our support team is available via phone, email, and live chat.",
//           },
//           {
//             question: "Is there a mobile app?",
//             answer:
//               "Yes, our mobile apps for iOS and Android allow you to track time, access cases, communicate with clients, and manage your practice on the go.",
//           },
//           {
//             question: "What integrations do you offer?",
//             answer:
//               "We integrate with popular tools including QuickBooks, Outlook, Gmail, Dropbox, LawPay, and many others. We also offer API access for custom integrations.",
//           },
//         ].map((faq, index) => (
//           <motion.div key={index} variants={fadeInUp}>
//             <Accordion sx={{ mb: 2 }}>
//               <AccordionSummary expandIcon={<ExpandMore />}>
//                 <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//                   {faq.question}
//                 </Typography>
//               </AccordionSummary>
//               <AccordionDetails>
//                 <Typography variant="body1" color="text.secondary">
//                   {faq.answer}
//                 </Typography>
//               </AccordionDetails>
//             </Accordion>
//           </motion.div>
//         ))}
//       </Box>
//     </motion.div>
//   </Container>
// );

// // Contact Section
// const ContactSection = () => (
//   <Box sx={{ backgroundColor: "#1976d2", py: 10 }} id="contact">
//     <Container maxWidth="lg">
//       <AnimatedSection>
//         <Typography
//           variant="h3"
//           align="center"
//           sx={{ mb: 6, fontWeight: "bold", color: "white" }}
//         >
//           Ready to Transform Your Practice?
//         </Typography>
//       </AnimatedSection>

//       <Grid container spacing={6}>
//         <Grid item xs={12} md={6}>
//           <motion.div
//             initial={{ opacity: 0, x: -50 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <Paper sx={{ p: 4, borderRadius: 4 }}>
//               <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
//                 Get Started Today
//               </Typography>
//               <Stack spacing={3}>
//                 <TextField fullWidth label="Full Name" variant="outlined" />
//                 <TextField fullWidth label="Email Address" variant="outlined" />
//                 <TextField fullWidth label="Law Firm Name" variant="outlined" />
//                 <TextField fullWidth label="Phone Number" variant="outlined" />
//                 <TextField
//                   fullWidth
//                   label="How can we help?"
//                   variant="outlined"
//                   multiline
//                   rows={4}
//                 />
//                 <Button
//                   variant="contained"
//                   size="large"
//                   fullWidth
//                   sx={{ py: 2, borderRadius: 8 }}
//                 >
//                   Start Free Trial
//                 </Button>
//               </Stack>
//             </Paper>
//           </motion.div>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <motion.div
//             initial={{ opacity: 0, x: 50 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <Box sx={{ color: "white" }}>
//               <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
//                 Contact Information
//               </Typography>
//               <Stack spacing={3}>
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Phone sx={{ mr: 2 }} />
//                   <Typography variant="body1">+1 (555) 123-4567</Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Email sx={{ mr: 2 }} />
//                   <Typography variant="body1">
//                     hello@legaltechpro.com
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <LocationOn sx={{ mr: 2 }} />
//                   <Typography variant="body1">
//                     123 Legal Street, Suite 100
//                     <br />
//                     New York, NY 10001
//                   </Typography>
//                 </Box>
//               </Stack>

//               <Typography variant="h6" sx={{ my: 3, fontWeight: "bold" }}>
//                 Follow Us
//               </Typography>
//               <Stack direction="row" spacing={2}>
//                 <IconButton sx={{ color: "white" }}>
//                   <LinkedIn />
//                 </IconButton>
//                 <IconButton sx={{ color: "white" }}>
//                   <Twitter />
//                 </IconButton>
//                 <IconButton sx={{ color: "white" }}>
//                   <Facebook />
//                 </IconButton>
//               </Stack>
//             </Box>
//           </motion.div>
//         </Grid>
//       </Grid>
//     </Container>
//   </Box>
// );

// // Footer
// const Footer = () => (
//   <Box sx={{ backgroundColor: "#212121", py: 6 }}>
//     <Container maxWidth="lg">
//       <Grid container spacing={4}>
//         <Grid item xs={12} md={4}>
//           <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//             <Gavel sx={{ mr: 1, color: "white" }} />
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: "bold", color: "white" }}
//             >
//               LegalTech Pro
//             </Typography>
//           </Box>
//           <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//             Empowering law firms with cutting-edge practice management
//             solutions.
//           </Typography>
//         </Grid>
//         <Grid item xs={12} md={8}>
//           <Grid container spacing={4}>
//             <Grid item xs={6} md={3}>
//               <Typography variant="h6" sx={{ color: "white", mb: 2 }}>
//                 Product
//               </Typography>
//               <Stack spacing={1}>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Features
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Pricing
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Security
//                 </Typography>
//               </Stack>
//             </Grid>
//             <Grid item xs={6} md={3}>
//               <Typography variant="h6" sx={{ color: "white", mb: 2 }}>
//                 Company
//               </Typography>
//               <Stack spacing={1}>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   About
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Careers
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Press
//                 </Typography>
//               </Stack>
//             </Grid>
//             <Grid item xs={6} md={3}>
//               <Typography variant="h6" sx={{ color: "white", mb: 2 }}>
//                 Support
//               </Typography>
//               <Stack spacing={1}>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Help Center
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Contact
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Training
//                 </Typography>
//               </Stack>
//             </Grid>
//             <Grid item xs={6} md={3}>
//               <Typography variant="h6" sx={{ color: "white", mb: 2 }}>
//                 Legal
//               </Typography>
//               <Stack spacing={1}>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Privacy
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Terms
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//                   Compliance
//                 </Typography>
//               </Stack>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>
//       <Box
//         sx={{
//           mt: 4,
//           pt: 4,
//           borderTop: "1px solid #424242",
//           textAlign: "center",
//         }}
//       >
//         <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
//           © 2025 LegalTech Pro. All rights reserved.
//         </Typography>
//       </Box>
//     </Container>
//   </Box>
// );

// // Main HomePage Component
// const HomePage = () => {
//   return (
//     <Box>
//       <Header />
//       <Box sx={{ pt: 8 }}>
//         <HeroSection />
//         <AboutSection />
//         <ServicesSection />
//         <TestimonialsSection />
//         <PricingSection />
//         <FAQSection />
//         <ContactSection />
//         <Footer />
//       </Box>
//     </Box>
//   );
// };

// export default HomePage;

import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import LandingImg from "../../assets/landing-page.webp";

const HomePage = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#f4f4f4", minHeight: "100vh", py: 4 }}>
        <Box
          sx={{
            maxWidth: "75rem",
            mx: "auto",
            px: 2,
          }}
        >
          {/* Hero Section */}
          <Grid container spacing={4} alignItems="center" sx={{ mb: 8 }}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="body1"
                color="primary"
                sx={{ fontSize: "1rem" }}
                gutterBottom
              >
                Intellectual Property Optimized
              </Typography>

              <Typography
                variant="h3"
                color="text.primary"
                sx={{ fontWeight: "bold", mb: 2 }}
              >
                Everything your law firm needs. All in one place.
              </Typography>

              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Simplify every aspect of your law firm, from billing to
                communication and document management.
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ height: "80%" }}>
                <img
                  src={LandingImg}
                  alt="Company Logo"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    filter: "drop-shadow(0rem 1rem 0.5rem #00000050)",
                  }}
                  onError={(e) => {
                    e.onerror = null;
                    e.target.src = require("../../assets/no-preview.webp");
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* About Section */}
          <Box sx={{ mb: 8 }}>
            <Typography
              variant="h4"
              align="center"
              color="text.primary"
              sx={{ mb: 4, fontWeight: "bold" }}
            >
              Why Our Agency
            </Typography>

            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mb: 2, fontSize: "0.9rem" }}
                >
                  Our agency is built on a foundation of legal expertise and a
                  deep understanding of the complexities of the legal industry.
                  We specialize in providing tailored solutions to help legal
                  professionals streamline their practices and achieve better
                  results for their clients.
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  {[
                    { title: "9875", subtitle: "Satisfied Clients" },
                    { title: "7894", subtitle: "Project Launched" },
                    { title: "65", subtitle: "Years Completed" },
                  ].map((stat, index) => (
                    <Grid item xs={4} key={index}>
                      <Card variant="outlined">
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography variant="h5" color="primary">
                            {stat.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {stat.subtitle}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {/* Services Section */}
          <Box sx={{ mb: 8 }}>
            <Typography
              variant="h4"
              align="center"
              color="text.primary"
              sx={{ mb: 4, fontWeight: "bold" }}
            >
              Our Specialization
            </Typography>

            <Grid container spacing={3}>
              {[
                {
                  icon: "🔭",
                  title: "Strategy & Research",
                  description:
                    "Mauris ut felis malesuada eros varius tristique a at orci.",
                },
                {
                  icon: "💻",
                  title: "Web Development",
                  description:
                    "Mauris ut felis malesuada eros varius tristique a at orci.",
                },
                {
                  icon: "🌐",
                  title: "Web Solution",
                  description:
                    "Mauris ut felis malesuada eros varius tristique a at orci.",
                },
              ].map((service, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Card variant="outlined" sx={{ height: "100%" }}>
                    <CardContent sx={{ textAlign: "center" }}>
                      <Typography variant="h2" sx={{ mb: 2 }}>
                        {service.icon}
                      </Typography>
                      <Typography variant="h6" sx={{ mb: 2 }}>
                        {service.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {service.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HomePage;
